const getDiffProperties = (_etalon, _obj) => {
    const keys = new Set([...Object.keys(_obj), ...Object.keys(_etalon)]);

    const diff = [],
        same = [];
    keys.forEach(_key => {
        const prop = { key: _key, val: _obj[_key] };
        if (Object.is(_etalon[_key], _obj[_key])) same.push(prop);
        else diff.push(prop);
    });
    return { diff, same };
};

export default getDiffProperties;
